// extracted by mini-css-extract-plugin
export default {"shadowContainer":"shadowWrapper_shadowContainer__K0XfC"};